import axios from "axios";

// In production the frontend is served by the same server that hosts the API,
// so we use a relative /api/ path — works on any domain without hardcoding.
// In local development (localhost:3000) we proxy to localhost:8080.
const baseURL = process.env.REACT_APP_API_URL ||
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
    ? "http://localhost:8080/api/"
    : "/api/");

const api = axios.create({ baseURL });

// Attach X-User-Role and X-User-Name headers from session storage so the
// backend can enforce role rules (e.g. locking invoice_number edits).
api.interceptors.request.use(cfg => {
  try {
    const raw = sessionStorage.getItem('ihrd_user');
    if (raw) {
      const u = JSON.parse(raw);
      if (u && u.role)     cfg.headers['X-User-Role'] = u.role;
      if (u && u.username) cfg.headers['X-User-Name'] = u.username;
    }
  } catch (_) {}
  return cfg;
});

export default api;
